import type { PaymentProtectionFeatureConfig } from '../../../types/insurances/PaymentProtectionFeatureConfig';

export const paymentProtection: PaymentProtectionFeatureConfig = {
    overview: {
        details: {
            fallbackAssistancePhonesKey: null,
            fallbackAssistanceEmailsKey: null,
        },
    },
    settings: {
        details: {
            showStatus: false,
        },
    },
};
